require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./container"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./container"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./container")) : factory(root["./utils"], root["./container"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__18__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[56],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(484);


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Slideout = _interopRequireDefault(__webpack_require__(485));

exports["default"] = _Slideout["default"];
exports.Slideout = _Slideout["default"];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = __webpack_require__(14);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _container = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(4);

var _Slideout = _interopRequireDefault(__webpack_require__(486));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var slideoutClassName = _Slideout["default"].SlideoutClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var isKey = _utils.keyboardUtils.isKey,
    keyNames = _utils.keyboardUtils.keyNames;

var Slideout = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Slideout, _Component);

  function Slideout(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTransitionEnd", function (e) {
      if (e.propertyName === 'transform') {
        // fires the onOpend/onHidden callback when sliding transition is end
        var _this$props = _this.props,
            active = _this$props.active,
            onOpened = _this$props.onOpened,
            onHidden = _this$props.onHidden;

        if (active) {
          _this._addClickAwayEventListener();

          onOpened(e);
        } else {
          onHidden(e);
        }

        _this.setState({
          showChildren: active
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onAnimationEnd", function (e) {
      var _this$props2 = _this.props,
          active = _this$props2.active,
          onOpened = _this$props2.onOpened;

      _this._addClickAwayEventListener();

      onOpened(e);

      _this.setState({
        showChildren: active,
        hasAnimation: false
      });

      (0, _reactDom.findDOMNode)((0, _assertThisInitialized2["default"])(_this)).removeEventListener('animationend', _this._onAnimationEnd);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_clickAwayEventListener", function (e) {
      var _this$props3 = _this.props,
          onClickAway = _this$props3.onClickAway,
          containerRef = _this$props3.containerRef;
      var parent = !containerRef ? (0, _assertThisInitialized2["default"])(_this) : containerRef;

      if (!(0, _reactDom.findDOMNode)(parent).contains(e.target)) {
        onClickAway(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var onClose = _this.props.onClose;

      if (isKey(e, keyNames.ESCAPE)) {
        onClose(e);
        (0, _reactDom.findDOMNode)((0, _assertThisInitialized2["default"])(_this)).blur();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResizeStop", function (event, data) {
      var _this$props4 = _this.props,
          onClickAway = _this$props4.onClickAway,
          onResizeStop = _this$props4.onResizeStop;

      if (onClickAway) {
        // temporarily remove the clickaway listener to prevent the slideout being automatically collapsed if it reaches the max width/height
        window.removeEventListener('click', _this._clickAwayEventListener);
        setTimeout(function () {
          window.addEventListener('click', _this._clickAwayEventListener);
        });
      }

      onResizeStop(event, data);
    });
    var _this$props5 = _this.props,
        _active = _this$props5.active,
        animationOnRender = _this$props5.animationOnRender;
    _this.state = {
      showChildren: _active,
      hasAnimation: animationOnRender
    };
    return _this;
  }

  var _proto = Slideout.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _this$props6 = this.props,
        active = _this$props6.active,
        animationOnRender = _this$props6.animationOnRender;

    if (active) {
      this._addListeners();

      if (!animationOnRender) {
        setTimeout(function () {
          // when slideout is opened after mount and no animation on render , adding the clickAway event listener, since in other cases clickAway listener is added when sliding out transition is end,
          // Adding this listener after a cycle is to prevent unexpected closing effect from a clicking event
          _this2._addClickAwayEventListener();
        });
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevStates) {
    var prevActiveProp = prevProps.active;
    var _this$props7 = this.props,
        curActiveProp = _this$props7.active,
        autoFocus = _this$props7.autoFocus;
    var prevShowChildrenState = prevStates.showChildren;
    var curShowChildrenState = this.state.showChildren;

    if (!prevActiveProp && curActiveProp) {
      this._addListeners();
    } else if (prevShowChildrenState && !curShowChildrenState) {
      this._removeListeners();
    } else if (!prevShowChildrenState && curShowChildrenState && autoFocus) {
      (0, _reactDom.findDOMNode)(this).focus();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._removeListeners();
  };

  _proto._addClickAwayEventListener = function _addClickAwayEventListener() {
    var onClickAway = this.props.onClickAway;

    if (onClickAway) {
      window.addEventListener('click', this._clickAwayEventListener);
    }
  };

  _proto._addListeners = function _addListeners() {
    var hasAnimation = this.state.hasAnimation;
    (0, _reactDom.findDOMNode)(this).addEventListener('transitionend', this._onTransitionEnd);

    if (hasAnimation) {
      (0, _reactDom.findDOMNode)(this).addEventListener('animationend', this._onAnimationEnd);
    }
  };

  _proto._removeListeners = function _removeListeners() {
    var onClickAway = this.props.onClickAway;

    if (onClickAway) {
      window.removeEventListener('click', this._clickAwayEventListener);
    }

    (0, _reactDom.findDOMNode)(this).removeEventListener('transitionend', this._onTransitionEnd);
  };

  _proto.render = function render() {
    var _cx;

    var _this$props8 = this.props,
        width = _this$props8.width,
        height = _this$props8.height,
        children = _this$props8.children,
        style = _this$props8.style,
        active = _this$props8.active,
        toDirection = _this$props8.toDirection,
        resizable = _this$props8.resizable,
        resizeDirection = _this$props8.resizeDirection,
        resizeMaxConstraintsX = _this$props8.resizeMaxConstraintsX,
        resizeMaxConstraintsY = _this$props8.resizeMaxConstraintsY,
        resizeMinConstraintsX = _this$props8.resizeMinConstraintsX,
        resizeMinConstraintsY = _this$props8.resizeMinConstraintsY,
        onResizeStart = _this$props8.onResizeStart,
        onResize = _this$props8.onResize,
        className = _this$props8.className,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props8, ["width", "height", "children", "style", "active", "toDirection", "resizable", "resizeDirection", "resizeMaxConstraintsX", "resizeMaxConstraintsY", "resizeMinConstraintsX", "resizeMinConstraintsY", "onResizeStart", "onResize", "className"]);
    var _this$state = this.state,
        showChildren = _this$state.showChildren,
        hasAnimation = _this$state.hasAnimation;
    var slideoutComponentClass = (0, _utils.classnames)("" + slideoutClassName, (_cx = {}, _cx["" + toDirection] = toDirection, _cx.hasAnimation = hasAnimation, _cx.active = active, _cx));
    var sharedProps = (0, _extends2["default"])({}, sanitize(others, Slideout), {
      tabIndex: -1,
      // can only be focusable programatically, not through TAB key
      className: slideoutComponentClass + " " + className,
      onKeyDown: this._onKeyDown
    });

    var slideoutChildren = /*#__PURE__*/_react["default"].createElement("div", {
      className: slideoutClassName + "-children"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: slideoutClassName + "-children-wrapper",
      style: (0, _extends2["default"])({}, style)
    }, children));

    if (resizable) {
      var resizeProps = {
        resizable: true,
        resizeDirection: resizeDirection,
        resizeMaxConstraintsX: resizeMaxConstraintsX,
        resizeMaxConstraintsY: resizeMaxConstraintsY,
        resizeMinConstraintsX: resizeMinConstraintsX,
        resizeMinConstraintsY: resizeMinConstraintsY,
        onResizeStop: this._onResizeStop,
        onResizeStart: onResizeStart,
        onResize: onResize
      };
      return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sharedProps, resizeProps, {
        width: width,
        height: height
      }), (active || showChildren) && slideoutChildren);
    }

    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sharedProps, {
      style: {
        width: width,
        height: height
      }
    }), (active || showChildren) && slideoutChildren);
  };

  return Slideout;
}(_react.Component);

exports["default"] = Slideout;
(0, _defineProperty2["default"])(Slideout, "defaultProps", {
  active: false,
  toDirection: 'right',
  width: '100%',
  height: '100%',
  resizable: false,
  onHidden: function onHidden() {},
  onOpened: function onOpened() {},
  onClose: function onClose() {},
  onResizeStart: function onResizeStart() {},
  onResizeStop: function onResizeStop() {},
  onResize: function onResize() {},
  className: '',
  autoFocus: true,
  style: {},
  animationOnRender: false
});
(0, _defineProperty2["default"])(Slideout, "propTypes", {
  /** Toggles to show the slide in and out effect, by default, slideout pannel is hidden */
  active: _propTypes["default"].bool,

  /** Custom styles passed to the slideout */
  style: _propTypes["default"].object,
  autoFocus: _propTypes["default"].bool,

  /** Slideout direction */
  toDirection: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),

  /** Width of the slideout */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Height of the slideout */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Resizability flag, it will be horizontally resizable if turned to true */
  resizable: _propTypes["default"].bool,

  /** Defines resize directions, can be vertical, horizontal or both direction */
  resizeDirection: _propTypes["default"].oneOf(['x', 'y', 'both', 'none']),

  /** Callback function called after panel is hidden */
  onHidden: _propTypes["default"].func,
  onClose: _propTypes["default"].func,

  /** Callback function called after panel is opened */
  onOpened: _propTypes["default"].func,

  /** Callback function called when click away, typical implemention to achieve auto collapse is to set the active prop to false */
  onClickAway: _propTypes["default"].func,
  onResize: _propTypes["default"].func,
  onResizeStart: _propTypes["default"].func,
  onResizeStop: _propTypes["default"].func,

  /** Works together with onClickAway callback. Defines an area where clickaway callback function won't trigger. By default this area is this slideout node itself */
  containerRef: _propTypes["default"].object,
  children: _propTypes["default"].node,
  resizeMinConstraintsX: _propTypes["default"].number,
  resizeMinConstraintsY: _propTypes["default"].number,
  resizeMaxConstraintsX: _propTypes["default"].number,
  resizeMaxConstraintsY: _propTypes["default"].number,
  className: _propTypes["default"].string,
  animationOnRender: _propTypes["default"].bool
});

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(487);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "@keyframes sliding-right{0%{transform:translateX(0%)}100%{transform:translateX(100%)}}@keyframes sliding-left{0%{transform:translateX(0%)}100%{transform:translateX(-100%)}}@keyframes sliding-top{0%{transform:translateY(0%)}100%{transform:translateY(-100%)}}@keyframes sliding-bottom{0%{transform:translateY(0%)}100%{transform:translateY(100%)}}.ba-common-slideout{position:absolute;opacity:0;visibility:hidden}.ba-common-slideout:focus{outline:none}.ba-common-slideout.react-resizable{position:absolute}.ba-common-slideout-children{height:100%;width:100%;position:relative;opacity:0.99}.ba-common-slideout-children-wrapper{background-color:#fff;width:100%;height:100%}.ba-common-slideout-children .ba-common-slideout{z-index:-1}.ba-common-slideout.is-active{opacity:1;visibility:visible}.ba-common-slideout:not(.is-active) .ba-common-slideout{opacity:0;visibility:hidden}.ba-common-slideout.is-right{top:0;right:0}.ba-common-slideout.is-right.is-active{transform:translateX(100%)}.ba-common-slideout.is-right.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-right;animation-duration:.4s}.ba-common-slideout.is-left{top:0;left:0}.ba-common-slideout.is-left.is-active{transform:translateX(-100%)}.ba-common-slideout.is-left.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-left;animation-duration:.4s}.ba-common-slideout.is-top{left:0;top:0}.ba-common-slideout.is-top.is-active{transform:translateY(-100%)}.ba-common-slideout.is-top.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-top;animation-duration:.4s}.ba-common-slideout.is-bottom{left:0;bottom:0}.ba-common-slideout.is-bottom.is-active{transform:translateY(100%)}.ba-common-slideout.is-bottom.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-bottom;animation-duration:.4s}.ba-common-slideout{transition:transform .4s ease-in-out,opacity .4s ease-in-out,visibility .4s ease-in-out;background-color:#fff}@media screen and (-ms-high-contrast: active){.ba-common-slideout .ba-common-svgIcon{fill:yellow}.ba-common-slideout .react-resizable-handle{background-color:#595859}}\n", ""]);

// exports
exports.locals = {
	"SlideoutClassName": "\"ba-common-slideout\""
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[483,0]]]);
});